import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SurveyForm from "./Components/SurveyForm"; // Importera din SurveyForm-komponent
import CreateInvite from "./Components/CreateInvite";
import PublicFeedback from "./Components/PublicFeedback";
import Privacy from "./Components/Privacy";
import Visualization from "./Components/Visualization"; // Importera din Visualization-komponent
import ExportData from "./Components/ExportData";
import FormBuilder from "./Components/FormBuilder";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import ProtectedRoute from "./Components/ProtectedRoute";
import Login from "./Components/Login";
import Home from "./Components/Home";
import Account from "./Components/Account";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase"; // din path
import { getTenantIdFromHost } from "./Tenant/getTenantId";

const App = () => {
  const [tenant, setTenant] = useState(null);
  const [tenantLoading, setTenantLoading] = useState(true);
  const tenantId = getTenantIdFromHost();

  function applyThemeVars(theme) {
    const root = document.documentElement;
    if (!theme) return;

    if (theme.primary) root.style.setProperty("--primary", theme.primary);
    if (theme.secondary) root.style.setProperty("--secondary", theme.secondary);
    if (theme.background)
      root.style.setProperty("--background", theme.background);
    if (theme.text) root.style.setProperty("--text", theme.text);
    if (theme.hover) root.style.setProperty("--hover", theme.hover);
    if (theme.navbar) root.style.setProperty("--navbar", theme.navbar);
    if (theme.navIcons) root.style.setProperty("--navIcons", theme.navIcons);
    if (theme.boxShadow) root.style.setProperty("--boxShadow", theme.boxShadow);
    if (theme.button) root.style.setProperty("--button", theme.button);
    if (theme.pubHeader) root.style.setProperty("--pubHeader", theme.pubHeader);
    if (theme.backgroundImg)
      root.style.setProperty(
        "--backgroundImg",
        `url("${theme.backgroundImg}")`,
      );
  }

  useEffect(() => {
    (async () => {
      try {
        const snap = await getDoc(
          doc(db, "tenants", tenantId, "public", "config"),
        );
        if (snap.exists()) {
          const data = snap.data();

          setTenant({ id: tenantId, ...data });
          applyThemeVars(data);
        } else {
          // Fallback om tenant saknas
          setTenant({ id: tenantId, name: tenantId });
        }
      } catch (e) {
        console.error("Failed to load tenant config", e);
      } finally {
        setTenantLoading(false);
      }
    })();
  }, []);

  if (tenantLoading) return null; // eller en spinner
  if (!tenantId) {
    return <div className="appLoader" />;
  }
  return (
    <Router basename="/">
      <div>
        <Navbar />
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* <Route path="/account" element={<Account />} /> */}
          <Route path="/" element={<Home />} />
          <Route
            path="/builder"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <FormBuilder />
              </ProtectedRoute>
            }
          />{" "}
          {/* Skapa nytt formulär */}
          <Route
            path="/builder/:surveyId"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <FormBuilder />
              </ProtectedRoute>
            }
          />{" "}
          {/* Redigera existerande formulär */}
          <Route
            path="/survey"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <SurveyForm />
              </ProtectedRoute>
            }
          />
          {/* Fyll i formulär */}
          <Route
            path="/survey/:surveyId"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <SurveyForm />
              </ProtectedRoute>
            }
          />
          {/* E-posta i formulär */}
          <Route
            path="/createInvite/:surveyId"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <CreateInvite />
              </ProtectedRoute>
            }
          />
          {/* stat. formulär */}
          <Route
            path="/visualize"
            element={
               <ProtectedRoute allowedRoles={["admin", "manager", "employee"]}>
                <Visualization />
              </ProtectedRoute>
            }
          />
          <Route
            path="/export"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <ExportData />
              </ProtectedRoute>
            }
          />
          <Route path="/feedback/:token" element={<PublicFeedback />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>

       <Footer/>
      </div>
    </Router>
  );
};

export default App;
